import { IlogisticServiceTrelloCardData } from '../../../../../../../types/services';
import LogisticsOriginAndDestination from '../../../../LogisticsServiceTrelloCard/Components/LogisticsOriginAndDestination/LogisticsOriginAndDestination';

import './LogisticsOriginAndDestinationInfo.scss';

interface LogisticsOriginAndDestinationInfoProps {
  cardData: IlogisticServiceTrelloCardData;
}

export const LogisticsOriginAndDestinationInfo = ({ cardData }: LogisticsOriginAndDestinationInfoProps) => {
  return (
    <div className="logisticsOriginAndDestinationInfo">
      <span>
        {cardData?.organizationName} - SL N° {cardData?.id}
      </span>
      <span>|</span>
      <LogisticsOriginAndDestination origin={cardData?.origin} destination={cardData?.destination} />
    </div>
  );
};
